import { useAuth } from "../../context/AuthContext"
import { useNavigate, Link } from "react-router-dom"
import './login.css'
import './style.css'
import { useTranslation } from 'react-i18next';
import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../Helpers/apiConfig";

// GOOGLE AUTH İMPORTLARI
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

export default function Login() {
    const navigate = useNavigate()
    const { setUser } = useAuth()
    const { t, i18n } = useTranslation();
    const { user } = useAuth();

    const [msg, setMsg] = useState([]);

    const traceUserLogin = async (authData) => {
        try {
            const userInfo = authData.user || authData.User;
            const userDetail = authData.detail || authData.Detail;

            const userId = userInfo?.id;
            const fullName = userInfo?.fullName;
            const schoolId = userDetail?.schoolId;

            let mappedRole = "";
            if (userInfo?.isManager) mappedRole = "manager";
            else if (userInfo?.isStudent) {
                mappedRole = userInfo?.isIndividual ? "schoolstudent" : "individualstudent";
            } else if (userInfo?.roleName === "Teacher") mappedRole = "teacher";
            else mappedRole = "admin";

            await axios.post("https://express.heryerdeingilizce.com/api/user-trace/ping", {
                userId: userId,
                schoolId: schoolId || null,
                fullName: fullName,
                userType: mappedRole
            });
        } catch (e) {
            console.error("Trace Hatası:", e);
        }
    };

    if (user) {
        window.location.href = "/";
    }

    // --- GOOGLE İLE GİRİŞ (VAR OLAN HESAP İÇİN) ---
    const handleGoogleLogin = async (credentialResponse) => {
        try {
            const res = await axios.post("https://api.heryerdeingilizce.com/api/User/GoogleLogin/GoogleLogin",
                { idToken: credentialResponse.credential });

            if (res.data.success) {
                const userData = res.data.data;
                await traceUserLogin(userData);
                const loginUser = {
                    name: userData.user?.fullName || userData.User?.fullName,
                    user: userData.user || userData.User,
                    token: userData.token || userData.Token,
                    tokenData: userData.tokenExpiryDate || userData.TokenExpiryDate,
                    role: userData.user?.roleName || userData.User?.roleName,
                    userDetail: userData.detail || userData.Detail,
                    educationals: userData.educationals || userData.Educationals || [],
                    educational: userData.educational || userData.Educational || null
                };
                setUser(loginUser);
            } else {
                setMsg(res.data.message);
            }
        } catch (err) {
            setMsg(err.response?.data?.message || "Bağlantı hatası.");
        }
    }

    // --- GOOGLE İLE KAYIT (YENİ HESAP İÇİN) ---
    const handleGoogleRegister = async (credentialResponse) => {
        try {
            const res = await axios.post("https://api.heryerdeingilizce.com/api/User/GoogleRegister/GoogleRegister",
                { idToken: credentialResponse.credential });

            if (res.data.success) {
                // Kayıt başarılıysa kullanıcıya bilgi verip otomatik login'e yönlendirebilirsin
                // Veya direkt bu token ile login metodunu tekrar çağırabilirsin.
                setMsg("Kaydınız başarıyla oluşturuldu! Şimdi 'Google ile Giriş Yap' butonuna basarak giriş yapabilirsiniz.");
                // navigate("/auth/login"); // Gerekirse sayfayı tazeleyebilirsin
            } else {
                setMsg(res.data.message);
            }
        } catch (err) {
            setMsg(err.response?.data?.message || "Kayıt sırasında hata oluştu.");
        }
    }

    const handleNormalLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${API_BASE_URL}/User/Authorize`, {
                username: document.getElementById("emaillogin").value,
                password: document.getElementById("loginpass").value
            });
            //    const res = await axios.post("https://api.heryerdeingilizce.com/api/User/Authorize", {
            //             username: document.getElementById("emaillogin").value,
            //             password: document.getElementById("loginpass").value
            //         });
            if (res.data.success) {
                const userData = res.data.data;
                await traceUserLogin(userData);
                const loginUser = {
                    name: userData.user.fullName,
                    user: userData.user,
                    token: userData.token,
                    tokenData: userData.tokenExpiryDate,
                    role: userData.user.roleName,
                    userDetail: userData.detail,
                    educationals: userData.educationals || [],
                    educational: userData.educational || null
                };
                setUser(loginUser);
            } else {
                setMsg(res.data.message);
            }
        } catch (err) {
            setMsg("Giriş başarısız.");
        }
    }
    if (user) {
        if (user.role === "Student") {
            setUser(prev => ({
                ...prev,
                role: "Öğrenci"
            }));
        } else if (user.role === "Manager") {
            setUser(prev => ({
                ...prev,
                role: "Yönetici"
            }));
        } else if (user.role === "Teacher") {
            setUser(prev => ({
                ...prev,
                role: "Öğretmen"
            }));
        }

        window.location.href = "/";
    }
    return (
        <GoogleOAuthProvider clientId="828157744682-s3357qbm9vegagthio8a7dvi476j4e1c.apps.googleusercontent.com">
            <div className="container-fluid h-custom">
                <div className="row d-flex justify-content-center align-items-center h-99">
                    <div className="col-md-9 col-lg-6 col-xl-5">
                        <img src="https://api.heryerdeingilizce.com/photo/8f973784-5f77-4ae5-b40e-dc5f9f93c4ed.png"
                            className="img-fluid" alt="Sample image" />
                    </div>
                    <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1" id="loginForm" >



                        {/* ÜST KISIM: GOOGLE İLE GİRİŞ */}
                        {/* <div className="d-flex justify-content-center mb-4">
                            <GoogleLogin
                                onSuccess={handleGoogleLogin}
                                onError={() => setMsg('Google bağlantısı kurulamadı.')}
                                text="signin_with" // "Google ile Oturum Açın"
                                shape="pill"
                                width="300"
                            />
                        </div> */}
                        <div className="row justify-content-center">
                            {/* Sol Buton: Kayıt Ol */}
                            {/* Mobilde tam ekran (col-12), orta ve büyük ekranlarda yarım ekran (col-md-6) kaplar */}
                            <div className="col-12 col-md-6">
                                <div className="d-flex flex-column align-items-center gap-2 mt-3">
                                    <div className="mt-2">
                                        <GoogleLogin
                                            onSuccess={handleGoogleRegister}
                                            text="signup_with" // "Google ile Kaydolun"
                                            shape="pill"
                                            size="large"
                                            width="250"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Sağ Buton: Giriş Yap */}
                            <div className="col-12 col-md-6">
                                <div className="d-flex flex-column align-items-center gap-2 mt-3">
                                    <div className="mt-2">
                                        <GoogleLogin
                                            onSuccess={handleGoogleLogin}
                                            onError={() => setMsg('Google bağlantısı kurulamadı.')}
                                            text="signin_with" // "Google ile Oturum Açın"
                                            shape="pill"
                                            size="large" // Genişliklerin eşit görünmesi için width yerine size="large" bırakmak bazen daha uyumlu olabilir
                                            width="250" // Genişlikleri eşit tutmak görsel olarak daha şık duracaktır
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="divider d-flex align-items-center my-4">
                            <p className="text-center fw-bold mx-3 mb-0 text-muted">VEYA</p>
                        </div>

                        <form onSubmit={handleNormalLogin}>
                            <b className="text-danger">{msg}</b>
                            <div className="form-outline mb-4">
                                <label className="form-label" htmlFor="emaillogin">{t("emailaddress")}</label>
                                <input type="email" id="emaillogin" className="form-control form-control-lg" required />
                            </div>
                            <div className="form-outline mb-3">
                                <label className="form-label" htmlFor="loginpass">{t("validpassword")}</label>
                                <input type="password" id="loginpass" className="form-control form-control-lg" required />
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="form-check mb-0">
                                    <input className="form-check-input me-2 " type="checkbox" id="form2Example3" />
                                    <label className="form-check-label" htmlFor="form2Example3"><h4>{t("rememberme")}</h4></label>
                                </div>
                                <button type="submit" className="btn btn-success btn-lg">{t("login")}</button>
                            </div>


                            <div class="text-center">
                                <Link to="/auth/resetpassword" class="btn btn-info btn-lg">{t("forgotpassword")}
                                </Link>                            <br /><br />
                                <h3>{t("donthaveanaccount")} &nbsp;
                                    <Link to="/auth/Register" class="link-info">
                                        {t("register")}
                                    </Link>
                                </h3>


                            </div>

                        </form>


                    </div>
                </div >
            </div >
        </GoogleOAuthProvider>
    )
}



// <div >
//     <Link to="/auth/resetpassword">{t("forgotpassword")}</Link>
//     <hr />
//     <h3>{t("donthaveanaccount")}</h3>
//     <div className="d-flex flex-column align-items-center gap-2 mt-3">
//         {/* NORMAL KAYIT LİNKİ */}
//         <Link to="/auth/Register" className="btn btn-outline-info w-75">
//             {t("register")} (E-posta ile)
//         </Link>

//         {/* ALT KISIM: GOOGLE İLE KAYIT OL BUTONU */}
//         <div className="mt-2">
//             <GoogleLogin
//                 onSuccess={handleGoogleRegister}
//                 text="signup_with" // "Google ile Kaydolun"
//                 shape="pill"
//                 size="medium"
//                 width="250"
//             />
//         </div>
//     </div>
// </div>